import { headers } from './constants';
import axios from 'axios';
import { SCENARIO_BASE_URL } from 'constants/api';
import queryString from 'query-string';

export const scenarioTwoAPI = {
    fetchStats: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/stats?${queryString.stringify(params.requestParams)}`,
                {
                    headers
                }
            )
            .then((response) => response.data),
    fetchOutliers: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/outliers?${queryString.stringify(params.requestParams)}`,
                {
                    headers
                }
            )
            .then((response) => response.data),
    fetchBreachCategory: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/breach-category?${queryString.stringify(
                    params.requestParams
                )}`,
                {
                    headers
                }
            )
            .then((response) => response.data),
    fetchTrendData: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/trend?${queryString.stringify(params.requestParams)}`,
                {
                    headers
                }
            )
            .then((response) => response.data),
    fetchTopFiveRms: (params) =>
        axios
            .get(
                `${SCENARIO_BASE_URL}${
                    params.scenario
                }/top-five?${queryString.stringify(params.requestParams)}`,
                {
                    headers
                }
            )
            .then((response) => response.data)
};
